import { Dayjs } from 'dayjs'

export interface NewsFormValues {
  id: string
  contentType: string
  title: string
  tag: string
  site: string
  date: Dayjs | null
  description: string
  body: string
  image: File | string | null
  document: File | string | null
}

export const INITIAL_NEWS_VALUES: NewsFormValues = {
  id: '',
  contentType: 'noticia',
  title: '',
  tag: '',
  site: 'Sede Principal',
  date: null,
  description: '',
  body: '',
  image: null,
  document: null,
}

export const CONTENT_TYPES = [
  { value: 'noticia', label: 'Noticia' },
  { value: 'comunicado', label: 'Comunicado' },
]
